export default {
  title: 'Prestataires de livraison',
};
